import React from 'react';
import PropTypes from 'prop-types';
import MaterialListItem from 'material-ui/List/ListItem';

const ListItem = (props) => {
    const {
        children,
        initiallyOpen,
        leftCheckbox,
        leftIcon,
        nestedItems,
        onNestedListToggle,
        primaryText,
        primaryTogglesNestedList,
    } = props;

    return (
        <MaterialListItem
            initiallyOpen={ initiallyOpen }
            leftCheckbox={ leftCheckbox }
            leftIcon={ leftIcon }
            nestedItems={ nestedItems }
            onNestedListToggle={ onNestedListToggle }
            primaryText={ primaryText }
            primaryTogglesNestedList={ primaryTogglesNestedList }
        >
            { children }
        </MaterialListItem>
    );
};

ListItem.propTypes = {
    children: PropTypes.node,
    initiallyOpen: PropTypes.bool,
    leftCheckbox: PropTypes.element,
    leftIcon: PropTypes.element,
    nestedItems: PropTypes.array,
    onNestedListToggle: PropTypes.func,
    primaryText: PropTypes.string,
    primaryTogglesNestedList: PropTypes.bool,
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/ui/list/ListItem.js